@if (atgardTypes?.length > 0) {
  <div class="legend-panel">
    <div class="legend-label">
      Skogsvård på kontraktet
    </div>
    <div class="legend-flex-panel">
      @for (atgardtype of atgardTypes; track atgardtype) {
        <div>
          <rask-pill-toggle-button
            [colorTheme]="atgardtype.colorTheme"
            [ngModel]="atgardtype.group === selectedTypeGroup"
            (change)="toggled(atgardtype, $event)"
            (hoverChange)="hoverChange(atgardtype, $event)">
            {{atgardtype.text}}
          </rask-pill-toggle-button>
        </div>
      }
    </div>
  </div>
}